// Types for form data
export interface VenueAddress {
  street: string;
  suburb: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
}

export interface BusinessHours {
  [key: string]: {
    open: string;
    close: string;
    closed: boolean;
  };
}

export interface ExistingVenue {
  id: string;
  name: string;
  tradingName: string;
  address: string;
  businessType?: string;
  ownerId?: string;
  ownership?: {
    adminId?: string;
    adminName?: string;
    adminEmail?: string;
  };
  portalStatus: string;
  isVenuePortalEnabled: boolean;
  createdAt: any;
  analytics?: {
    totalSearches?: number;
    monthlySearches?: number;
  };
}

export interface VenueFormData {
  // Basic Information
  businessName: string;
  tradingName: string;
  email: string;
  phone: string;
  abn: string;
  businessType: string;
  
  // Address
  address: VenueAddress;
  
  // Profile Information
  description: string;
  website: string;
  priceRange: string;
  cuisine: string[];
  amenities: string[];
  
  // Capacity
  maxCapacity?: number | string; // optional — string during form input, number on save

  // Business Hours
  businessHours: BusinessHours;
  
  // Settings
  marketingConsent: boolean;
  termsAccepted: boolean;
  privacyPolicyAccepted: boolean;
}

export interface VenueApprovalRequest {
  venueId?: string; // For claims, undefined for new venues
  adminId: string;
  adminName: string;
  adminEmail: string;
  requestType: 'claim' | 'create';
  venueData: Partial<VenueFormData>;
  businessName: string;
  tradingName: string;
  address: string;
  businessType: string;
  justification?: string; // Why they should own this venue
  supportingDocuments?: string[]; // URLs to uploaded docs
  status: 'pending' | 'approved' | 'rejected';
  submittedAt: any;
  reviewedAt?: any;
  reviewedBy?: string;
  reviewNotes?: string;
}

export const BUSINESS_TYPES = [
  'Restaurant',
  'Cafe',
  'Bar',
  'Fast Food',
  'Fine Dining',
  'Bakery',
  'Food Truck',
  'Pub',
  'Club',
  'Takeaway',
  'Other'
];

export const STATES = [
  'NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT'
];

export const PRICE_RANGES = [
  '$', '$$', '$$$', '$$$$'
];

export const CUISINE_OPTIONS = [
  'Australian', 'Italian', 'Chinese', 'Japanese', 'Thai', 'Indian', 'Mexican',
  'French', 'Greek', 'Mediterranean', 'Vietnamese', 'Korean', 'Lebanese',
  'American', 'British', 'Spanish', 'German', 'Modern Australian', 'Asian Fusion',
  'Vegetarian', 'Vegan', 'Seafood', 'Steakhouse', 'Pizza', 'Burger', 'Sushi',
  'Tapas', 'Deli', 'Bakery', 'Dessert', 'Coffee', 'Other'
];

export const AMENITY_OPTIONS = [
  'WiFi', 'Parking', 'Wheelchair Accessible', 'Outdoor Seating', 'Private Dining',
  'Takeaway', 'Delivery', 'Live Music', 'Kids Friendly', 'Pet Friendly',
  'Air Conditioning', 'Heating', 'Full Bar', 'Wine List', 'BYO', 'Credit Cards',
  'EFTPOS', 'Cash Only', 'Reservations', 'Walk-ins Welcome', 'Group Bookings',
  'Function Room', 'Catering', 'Late Night', 'Breakfast', 'Lunch', 'Dinner'
];

export const DAYS_OF_WEEK = [
  'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
];

export const DAY_LABELS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday'
};